/* Website-only email verification; never shares identity/device account credentials. */
(() => {
  'use strict';
  const words = {
    en: {busy:'Please wait…',failed:'Unable to complete this request. Please retry.',network:'Connection interrupted. Your request may have been saved. Retry without changing the form to safely recover the same receipt.',saved:'Request received. Reference: ',registered:'Registration complete. Reference: ',receipt:' We will email you at launch. Use the secure link in your email to view progress or cancel. No payment has been taken.',inquiryReceipt:' We will reply by email. Use the secure link in your email to view progress.',sent:'If this address can receive mail, a secure link will arrive shortly. Check your spam folder too.',expired:'This link or session has expired or was already used. Request a new link below.',empty:'No website registrations or inquiries for this verified email.',cancel:'Cancel registration and launch notification',cancelled:'Registration cancelled. No further launch notification will be sent.',quantity:'Quantity: ',status:'Status: ',reference:'Reference: ',reply:'Reply: ',verified:'Email verified. Your private requests are shown below.',ended:'Session ended on this browser tab.',refresh:'Loading requests…',storage:'This browser cannot keep the verification session. Allow session storage and request a new link.',statuses:{new:'Received',in_progress:'In progress',closed:'Closed',cancelled:'Cancelled'}},
    zh: {busy:'处理中…',failed:'操作未完成，请重试。',network:'连接中断，信息可能已经保存。请保持表单内容不变重试，以安全获取同一条回执。',saved:'已收到，编号：',registered:'登记成功，编号：',receipt:' 开售时我们会发邮件通知。您可通过邮件中的安全链接查看进度或取消登记。本次未收取任何费用。',inquiryReceipt:' 我们会通过邮件回复，您可通过邮件中的安全链接查看处理进度。',sent:'如果该邮箱能够收件，您将收到安全查询链接。也请检查垃圾邮件。',expired:'链接或会话已失效，或链接已使用，请在下方重新获取。',empty:'此已验证邮箱暂无官网登记或咨询。',cancel:'取消登记及开售提醒',cancelled:'已取消登记，不再发送开售提醒。',quantity:'数量：',status:'状态：',reference:'编号：',reply:'回复：',verified:'邮箱已验证，下方显示您的私人记录。',ended:'已退出当前浏览器标签页的查询。',refresh:'正在加载记录…',storage:'浏览器无法保存验证会话。请允许会话存储后重新获取链接。',statuses:{new:'已收到',in_progress:'处理中',closed:'已关闭',cancelled:'已取消'}}
  };
  document.querySelectorAll('[data-website-requests]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const locale = root.dataset.locale === 'zh' ? 'zh' : 'en';
    const t = words[locale];
    const base = root.dataset.apiBase.replace(/\/$/, '') + '/lead/v1';
    const storageKey = 'nscit.website.session:' + base;
    const form = root.querySelector('[data-request-form]');
    const access = root.querySelector('[data-access-form]');
    const notice = root.querySelector('[data-request-notice]');
    const accessNotice = root.querySelector('[data-access-notice]');
    const list = root.querySelector('[data-request-list]');
    const actions = root.querySelector('[data-session-actions]');
    const more = root.querySelector('[data-load-more]');
    let session = null;
    let pending = null;
    let listGeneration = 0;
    let beforeId = 0;
    try { session = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) { /* No persistent fallback for private credentials. */ }
    function clearSession() {
      session = null;
      listGeneration += 1;
      try { sessionStorage.removeItem(storageKey); } catch (_) { /* Already unavailable. */ }
      list.replaceChildren();
      actions.hidden = true;
      more.hidden = true;
      beforeId = 0;
    }
    if (!session || !session.sessionToken || Date.parse(session.expiresAt) <= Date.now() || !Number.isFinite(Date.parse(session.expiresAt))) clearSession();
    function show(node, message, error = false) {
      node.textContent = message;
      node.dataset.error = String(error);
      node.hidden = false;
    }
    async function request(path, { body, privateRequest = false, idempotencyKey } = {}) {
      const headers = { Accept: 'application/json' };
      if (body !== undefined) headers['Content-Type'] = 'application/json';
      if (privateRequest && session) headers['X-Website-Session'] = session.sessionToken;
      if (idempotencyKey) headers['Idempotency-Key'] = idempotencyKey;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(base + path, {method: body === undefined ? 'GET' : 'POST', headers, body: body === undefined ? undefined : JSON.stringify(body), credentials:'omit', cache:'no-store', referrerPolicy:'no-referrer', signal:controller.signal});
        const data = await response.json().catch(() => null);
        if (!response.ok) {
          if (privateRequest && (response.status === 401 || response.status === 403)) clearSession();
          const specific = response.status === 429 ? (locale === 'zh' ? '请求较频繁，请稍后再试。' : 'Too many requests. Please try again later.') : response.status === 422 ? (locale === 'zh' ? '请检查填写内容和长度后重试。' : 'Check the information and field lengths, then retry.') : t.failed;
          const error = new Error(response.status === 401 || response.status === 403 ? t.expired : specific);
          error.http = true;
          throw error;
        }
        if (!data || data.success === false) throw new Error(t.failed);
        return data.success === true ? data.data : data;
      } catch (error) {
        if (error.http) throw error;
        throw new Error(t.network);
      } finally { clearTimeout(timeout); }
    }
    async function busy(button, task) {
      if (button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = t.busy;
      try { await task(); } finally { button.disabled = false; button.textContent = original; }
    }
    function textElement(tag, text) {
      const node = document.createElement(tag);
      node.textContent = text;
      return node;
    }
    async function refresh(append = false) {
      const generation = ++listGeneration;
      if (!session) return;
      if (!append) { beforeId = 0; more.hidden = true; }
      show(accessNotice,t.refresh);
      try {
        const data = await request('/public/me/requests' + (append ? '?beforeId=' + encodeURIComponent(beforeId) : ''), {privateRequest:true});
        if (generation !== listGeneration || !session) return;
        if (!Array.isArray(data.items)) throw new Error(t.failed);
        if (!append) list.replaceChildren();
        actions.hidden = false;
        show(accessNotice,t.verified);
        if (!data.items.length) list.append(textElement('p', t.empty));
        data.items.forEach(item => {
          const card = textElement('article', '');
          card.className = 'nscit-website__record';
          card.dataset.requestId = item.id;
          card.append(textElement('h3', item.kind === 'interest' ? item.productCode : item.subject));
          card.append(textElement('p', t.reference + item.reference));
          card.append(textElement('p', t.status + (t.statuses[item.status] || item.status)));
          if (item.kind === 'interest') card.append(textElement('p', t.quantity + item.quantity));
          if (item.message) card.append(textElement('p', item.message));
          (item.replies || []).forEach(reply => card.append(textElement('p', t.reply + reply.message)));
          if (item.kind === 'interest' && item.status !== 'cancelled' && item.status !== 'closed') {
            const cancel = textElement('button', t.cancel);
            cancel.type = 'button';
            cancel.addEventListener('click', () => busy(cancel, async () => {
              try {
                await request('/public/me/requests/' + encodeURIComponent(item.id) + '/cancel', {body:{}, privateRequest:true});
                if (await refresh()) show(accessNotice,t.cancelled);
              } catch (error) { show(accessNotice,error.message,true); }
            }));
            card.append(cancel);
          }
          list.append(card);
        });
        beforeId = data.nextBeforeId || 0;
        more.hidden = !data.hasMore || !beforeId;
        return true;
      } catch (error) {
        if (generation === listGeneration || !session) {
          if (!append) list.replaceChildren();
          show(accessNotice,error.message,true);
        }
      }
    }
    const params = new URLSearchParams(location.search);
    const interestMode = root.dataset.mode === 'interest';
    const selectedProduct = interestMode ? (params.get('productCode') || '').trim().slice(0,64) : (params.get('productCode') || '').slice(0,64);
    form.elements.productCode.value = selectedProduct;
    if (interestMode) {
      root.querySelector('[data-selected-product]').textContent = selectedProduct;
      root.querySelector('[data-product-summary]').hidden = !selectedProduct;
      root.querySelector('[data-choose-product]').hidden = Boolean(selectedProduct);
      // Native validation runs before submit. Reveal optional invalid controls so
      // the browser can focus them instead of rejecting an unfocusable field.
      form.addEventListener('invalid', event => {
        const details = event.target.closest('[data-additional-info]');
        if (details) details.open = true;
      }, true);
    }
    if (params.get('subject') && form.elements.subject) form.elements.subject.value = params.get('subject').slice(0,200);
    const userType = form.elements.userType;
    function syncInquiryType() {
      if (!userType) return;
      const isDvt = userType.value === 'DVT1 Trial User';
      const dvt = form.querySelector('[data-dvt-fields]');
      dvt.hidden = !isDvt;
      dvt.disabled = !isDvt;
      dvt.querySelectorAll('[data-dvt-required]').forEach(field => { field.required = isDvt; });
      const dealer = form.querySelector('[data-dealer-fields]');
      dealer.hidden = userType.value !== 'Dealer';
      dealer.disabled = dealer.hidden;
      form.querySelector('[data-general-message]').hidden = isDvt;
      form.elements.message.disabled = isDvt;
      form.elements.message.required = !isDvt;
    }
    if (userType) { userType.addEventListener('change',syncInquiryType); syncInquiryType(); }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (interestMode && !selectedProduct) return;
      if (!form.reportValidity()) return;
      busy(form.querySelector('[type="submit"]'), async () => {
        const values = new FormData(form);
        const value = name => String(values.get(name) || '').trim();
        let message = value('message');
        if (value('userType') === 'DVT1 Trial User') {
          const fields = [['deviceSerialNumber','Device serial number'],['issueType','Issue type'],['actualBehavior','Actual behavior'],['expectedResult','Expected result'],['reproductionSteps','Reproduction steps'],['environment','Environment'],['appVersion','App version']];
          message = fields.filter(([key]) => value(key)).map(([key,label]) => label + ': ' + value(key)).join('\n\n');
        }
        if (root.dataset.mode === 'dealer' || value('userType') === 'Dealer') {
          const business = ['company','businessType','website','volume'].filter(key => value(key)).map(key => key + ': ' + value(key)).join('\n');
          if (business) message += '\n\n' + business;
        }
        if (value('userType')) message = 'User type: ' + value('userType') + '\n\n' + message;
        if ([...message].length > 4000) {
          show(notice,locale === 'zh' ? '留言和补充信息合计请勿超过 4000 字符。' : 'Keep your message and additional details within 4,000 characters in total.',true);
          return;
        }
        const body = {kind:root.dataset.mode === 'interest' ? 'interest' : 'inquiry',email:value('email'),productCode:value('productCode'),quantity:Number(value('quantity') || 1),name:value('name'),region:value('region'),subject:value('subject'),message,locale,sourceUrl:location.origin + location.pathname,newsletterOptIn:values.has('newsletterOptIn')};
        const signature = JSON.stringify(body);
        if (!pending || pending.signature !== signature) pending = {signature,key:crypto.randomUUID()};
        try {
          const result = await request('/public/requests', {body,idempotencyKey:pending.key});
          if (!result.accepted || !result.reference) throw new Error(t.failed);
          show(notice,(interestMode ? t.registered : t.saved) + result.reference + (interestMode ? t.receipt : t.inquiryReceipt));
          access.elements.email.value = body.email;
          notice.focus();
          // Keep the key for repeated clicks on the same values, including ambiguous network retries.
        } catch (error) { show(notice,error.message,true); notice.focus(); }
      });
    });
    access.addEventListener('submit', event => {
      event.preventDefault();
      busy(access.querySelector('[type="submit"]'), async () => {
        try {
          await request('/public/access/request', {body:{email:access.elements.email.value.trim(),locale}});
          show(accessNotice,t.sent);
        } catch (error) { show(accessNotice,error.message,true); }
      });
    });
    root.querySelector('[data-refresh]').addEventListener('click', event => busy(event.currentTarget,refresh));
    more.addEventListener('click', () => busy(more,() => refresh(true)));
    root.querySelector('[data-signout]').addEventListener('click', () => { clearSession(); show(accessNotice,t.ended); });
    form.querySelector('[type="submit"]').disabled = interestMode && !selectedProduct;
    access.querySelector('[type="submit"]').disabled = false;
    const fragment = new URLSearchParams(location.hash.slice(1));
    const token = fragment.get('verify');
    if (token) {
      history.replaceState(null, '', location.pathname + location.search);
      clearSession();
      show(accessNotice,t.busy);
      request('/public/access/verify', {body:{token}}).then(async result => {
        if (!result.sessionToken || !Number.isFinite(Date.parse(result.expiresAt))) throw new Error(t.failed);
        try { sessionStorage.setItem(storageKey,JSON.stringify(result)); } catch (_) { throw new Error(t.storage); }
        session = result;
        await refresh();
      }).catch(error => show(accessNotice,error.message,true));
    } else if (session) refresh();
  });
})();
